const floppyDisks = window.assetRegistry.diskicons
import DiskImageDialog from "./diskimagedialog"
import { handleSetDiskFromFile } from "./driveprops"
import { useState } from "react"
import { useTranslation } from "../../../i18n/useTranslation"

export const DiskImageChooser = (props: DisplayProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleSelect = (disk: string) => {
    setOpen(false)
    handleSetDiskFromFile(disk, props.updateDisplay)
  }

  const isTouchDevice = "ontouchstart" in document.documentElement

  return (
    <div style={{ userSelect: "none" }}>
      <img className={`disk-image${isTouchDevice ? " disk-image-small" : ""}`}
        src={floppyDisks} alt="disks"
        id="tour-disk-images"
        title={t("collection.chooseDiskImage")}
        onClick={handleClickOpen} />
      {open &&
        <DiskImageDialog
          onSelect={handleSelect}
          onClose={() => setOpen(false)}
          displayProps={props}
        />
      }
    </div>
  )
}
